import { PRIORITY_ENUM } from '../enum/priority.enum'
import { STATUS_ENUM } from '../enum/status.enum'

export const parseToDate = datetime => {
  return new Date(datetime).toLocaleString('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric'
  })
}

export const parseToTime = datetime => {
  return new Date(datetime).toLocaleString('pt-BR', {
    hour: '2-digit',
    minute: '2-digit'
  })
}

export const parseWaitingTime = createdAt => {
  const started = new Date(createdAt)
  const finished = new Date()
  let waitingTimeMs = finished.getTime() - started.getTime()
  if (waitingTimeMs < 0) waitingTimeMs = 0

  const totalMinutes = Math.floor(waitingTimeMs / 60000)
  const hours = Math.floor(totalMinutes / 60)
  const minutes = totalMinutes % 60

  if (totalMinutes < 1) {
    return 'Menos de 1 minuto'
  } else if (hours < 1) {
    return `${totalMinutes} minutos`
  } else if (hours === 1) {
    if (minutes === 0) {
      return `1 hora`
    } else {
      return `1 hora e ${minutes} minutos`
    }
  } else {
    if (minutes === 0) {
      return `${hours} horas`
    } else {
      return `${hours} horas e ${minutes} minutos`
    }
  }
}

export const parseDynamicWaitingTime = (createdAt, currentTime) => {
  const started = new Date(createdAt)
  const finished = new Date(currentTime)
  let waitingTimeMs = finished.getTime() - started.getTime()
  if (waitingTimeMs < 0) waitingTimeMs = 0
  const totalSeconds = Math.floor(waitingTimeMs / 1000)
  const hours = Math.floor(totalSeconds / 3600)
  const minutes = Math.floor((totalSeconds % 3600) / 60)
  const seconds = totalSeconds % 60
  const pad = num => String(num).padStart(2, '0')
  return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`
}

export const getAgeAndBirthDate = birthday => {
  const today = new Date()
  const birthDate = new Date(birthday)
  return `${parseToDate(birthday)} (${
    today.getFullYear() - birthDate.getFullYear()
  } anos)`
}

export const getPriorityColor = priority => {
  const colors = {
    [PRIORITY_ENUM.EMERGENCY]: 'bg-red-100 text-red-500',
    [PRIORITY_ENUM.VERY_URGENT]: 'bg-orange-100 text-orange-500',
    [PRIORITY_ENUM.URGENT]: 'bg-yellow-100 text-yellow-500',
    [PRIORITY_ENUM.NOT_VERY_URGENT]: 'bg-green-100 text-green-500',
    [PRIORITY_ENUM.NOT_URGENT]: 'bg-blue-100 text-blue-500',
    default: 'bg-gray-100 text-gray-500'
  }
  return colors[priority] || colors.default
}

export const getPriorityLabel = status => {
  const labels = {
    [PRIORITY_ENUM.EMERGENCY]: 'Emergência',
    [PRIORITY_ENUM.VERY_URGENT]: 'Muito urgente',
    [PRIORITY_ENUM.URGENT]: 'Urgente',
    [PRIORITY_ENUM.NOT_VERY_URGENT]: 'Pouco urgente',
    [PRIORITY_ENUM.NOT_URGENT]: 'Não urgente'
  }
  return labels[status] || status
}

export const getStatuses = () => {
  return [
    { label: 'Todos', value: null },
    { label: 'Aguardando', value: STATUS_ENUM.WAITING },
    { label: 'Em andamento', value: STATUS_ENUM.IN_PROGRESS },
    { label: 'Paciente na sala', value: STATUS_ENUM.PATIENT_IN_SESSION },
    { label: 'Concluído', value: STATUS_ENUM.FINISHED },
    {
      label: 'Cancelado pelo paciente',
      value: STATUS_ENUM.CANCELLED_BY_PATIENT
    },
    { label: 'Cancelado pelo médico', value: STATUS_ENUM.CANCELLED_BY_DOCTOR },
    { label: 'Cancelado pelo sistema', value: STATUS_ENUM.CANCELLED_BY_SYSTEM },
    { label: 'Paciente não compareceu', value: STATUS_ENUM.PATIENT_MISSED }
  ]
}

export const getStatusLabel = status => {
  const labels = {
    [STATUS_ENUM.WAITING]: 'Aguardando',
    [STATUS_ENUM.CANCELLED_BY_PATIENT]: 'Cancelado pelo paciente',
    [STATUS_ENUM.CANCELLED_BY_SYSTEM]: 'Cancelado pelo sistema',
    [STATUS_ENUM.CANCELLED_BY_DOCTOR]: 'Cancelado pelo médico',
    [STATUS_ENUM.PATIENT_MISSED]: 'Paciente não compareceu',
    [STATUS_ENUM.IN_PROGRESS]: 'Em andamento',
    [STATUS_ENUM.PATIENT_IN_SESSION]: 'Paciente na sala',
    [STATUS_ENUM.FINISHED]: 'Concluído'
  }
  return labels[status] || status
}

export const canStartAttendance = status => {
  return status === STATUS_ENUM.WAITING
}
